export const ISTOK_WEB = 'Istok Web, sans-serif';
export const INTER = 'Inter, sans-serif';
export const POPPINS = 'Poppins, sans-serif';
export const ROBOTO = 'Roboto, sans-serif';
export const JURA = 'Jura, sans-serif';
